import { render, staticRenderFns } from "./SwitchLang.vue?vue&type=template&id=1690afca&scoped=true"
import script from "./SwitchLang.vue?vue&type=script&lang=js"
export * from "./SwitchLang.vue?vue&type=script&lang=js"
import style0 from "./SwitchLang.vue?vue&type=style&index=0&id=1690afca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1690afca",
  null
  
)

export default component.exports